import React from 'react';
import styled from 'styled-components';
import TextDecorator from 'components/textDecorator/TextDecorator';
import ArticleDecorator from 'components/textDecorator/ArticleDecorator';
import { txt } from 'lang';
import { LandingContext } from 'contexts/LandingContext';


const WrappedContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100vw;
  height: ${props => props.height}px;
  justify-content:center;
  align-items:center;
  background-image : url('assets/images/backgrounds/2560/section9.png');
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  @media(max-width:1920px){
        background-image : url('assets/images/backgrounds/1920/section9.png');
  }
  @media(max-width:1440px){
    background-image : url('assets/images/backgrounds/team.png');
  }
  @media(max-width:1400px){
       justify-content:flex-end ;
  }  
  @media (max-width: 1280px) {
        background-image: url('assets/images/backgrounds/1280/section9.png');
  }
  @media(max-width:490px){
    background-image : url('assets/images/backgrounds/mobile/section9.png');
  }

`;
const PageContainer = styled.div`
    height: ${props => props.height - 194}px;
    @media(max-width:1400px){
        height: ${props => props.height - 116}px;
    }
`;
const Container = styled.div`
  height: 100%;
  display: flex;
  padding:0;
  max-width: 1800px;
  width:calc(100vw - 120px);
  align-items: center;
  justify-content:center;
  @media(max-width:490px){
    width:calc(100vw - 48px);
  }

`;
const Content = styled.div`
  display: flex;
  flex-direction: row;
  height:100%;
  width:100%;
  align-items: center;
  justify-content: space-between;
  @media(max-width:1024px) {
    flex-direction: column;
  }
`;
const PageContent = styled.div`
  width:730px;
  min-width: 481px;
  display: flex;
  flex-direction: column;
  justify-content: start;
  @media(max-width:1600px) {
    width: 481px;
  }
  @media(max-width:768px) {
    width:100%;
    margin-left: 20px;
    margin-right: 20px;
  }
  @media (max-width: 549px) {
    width: 200px;
    min-width: 316px;
    margin-left: 20px;
    margin-right: 20px;
  }
  @media (max-width: 490px) {
    width: 85vw;
    min-width: 80vw;
  }

`;
const PageContext = styled.div`
  margin-top: 20px;
  width:100%;
  @media (max-height: 800px) {
    margin-top: 5px;
  }
`;



const TeamIntro = ({ size }) => {
  const { lang } = React.useContext(LandingContext);
  const content = txt('section10', 'body', lang);
  const fontFamily = lang != "en" ? size.width < 490 ? 'SwissraD' : 'Israr-Syria' : 'Kusanagi';
  const querterRef = React.useRef();
  const txtContent = "This powerhouse team consists of innovative developers, long-time gamers, world-class artists, crypto lovers, highly influential marketers, and NFT enthusiasts working together to create a ground-breaking platform and an unforgettable Web3 metaverse experience."
  const txtContent1 = "At Metagate, transparency, integrity, and trust are at the forefront of everything we do. Our fully doxed team of like-minded professionals continues to grow, develop, and expand by the day, and we invite you to join us on this epic adventure into a multiverse of opportunities."


  const handleLink = (name) => {
    if (name === "anmar") {
      window.open('https://www.linkedin.com/in/anmaralharbi/');
    }
    else if (name === 'Mohannad') {
      window.open('https://www.linkedin.com/in/mohannadotaibi/')
    }
    window.open('https://www.linkedin.com/in/leitchsteve/')
  }

  
  return (
    <WrappedContainer height={size.height}>
      <PageContainer height={size.height}>
        <Container>
          <Content>
            <PageContent>
              <TextDecorator direction={'up'}
                uppercase="none"
                fontSize={32}
                content={'The team'}
                fontFamily={'Kusanagi'}
                width='fit-content'></TextDecorator>
              <PageContext>
                <ArticleDecorator content={txtContent}
                  fontFamily='Roboto'
                  fontSize={16}
                  lineHeight={22.4} />
                <div style={{ height: '15px' }}></div>
                <ArticleDecorator content={txtContent1}
                  fontFamily='Roboto'
                  fontSize={16}
                  lineHeight={22.4} />
              </PageContext>
            </PageContent>
            
          </Content>
        </Container>
      </PageContainer>
    </WrappedContainer>
  );
};

export default TeamIntro;